import { z } from 'zod';

const bucket = z.object({ id: z.string(), label: z.string(), value: z.number() });

export const reportQuery = z.object({ from: z.iso.date(), to: z.iso.date() });

/** Relatórios (SPEC §37). Valores em dinheiro vêm nulos para quem não vê o financeiro. */
export const reportDto = z.object({
  from: z.string(),
  to: z.string(),
  production: z.object({
    total: z.number(),
    byType: z.array(bucket),
    byCategory: z.array(bucket),
    byClient: z.array(bucket),
    byProject: z.array(bucket),
    byUser: z.array(bucket),
    /** Peças por semana no período. */
    timeline: z.array(z.object({ week: z.string(), value: z.number() })),
  }),
  approval: z.object({
    approved: z.number(),
    firstVersion: z.number(),
    secondVersion: z.number(),
    thirdPlus: z.number(),
    averageRevisions: z.number(),
    changesRequested: z.number(),
    pending: z.number(),
  }),
  deadlines: z.object({
    delivered: z.number(),
    onTime: z.number(),
    late: z.number(),
    noDeadline: z.number(),
    averageDays: z.number(),
  }),
  finance: z
    .object({
      invoicedCents: z.number(),
      receivedCents: z.number(),
      expensesCents: z.number(),
      marginCents: z.number(),
      pendingCents: z.number(),
    })
    .nullable(),
  clients: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      color: z.string(),
      materials: z.number(),
      minutes: z.number(),
      revenueCents: z.number().nullable(),
      expensesCents: z.number().nullable(),
      perMaterialCents: z.number().nullable(),
      perHourCents: z.number().nullable(),
      marginCents: z.number().nullable(),
    }),
  ),
  /** Tempo médio por tipo de material (relógio por material), base para precificação. */
  timeByType: z.array(
    z.object({
      id: z.uuid(),
      label: z.string(),
      minutes: z.number(),
      units: z.number(),
      perUnitMinutes: z.number(),
    }),
  ),
  team: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      delivered: z.number(),
      materials: z.number(),
      minutes: z.number(),
      openTasks: z.number(),
    }),
  ),
});
export type ReportDto = z.infer<typeof reportDto>;
